import script from "./alertModal.vue?vue&type=script&setup=true&lang=js"
export * from "./alertModal.vue?vue&type=script&setup=true&lang=js"

import "./alertModal.vue?vue&type=style&index=0&id=bb848156&lang=scss&scoped=true"

import exportComponent from "E:\\immm\\webim-vue-demo-vue3-miniCore\\webim-vue-demo-vue3-miniCore\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb848156"]])

export default __exports__